export const muiFormTheme = {
  MuiFormControl: {
    styleOverrides: {
      root: ({ theme: _theme }) => ({
        width: '100%',
        '.MuiInputLabel-root.Mui-focused': {
          color: 'inherit',
        },
        '.MuiFormHelperText-root': {
          margin: '0px',
          color: '#FF6363',
        },
      }),
    },
  },
};
